<template>
    <div v-if="显示">
        <el-alert @close="onClose" :title="title" :type="type" :show-icon="showIcon" :closable="closable" :center="center" :close-text="closeText" :effect="effect">
            <!-- <div>
                <div v-if="description">{{description}}</div>
                <slot v-else></slot>
                <div style="text-align: right;font-size: 12px;">
                    <el-link type="info">永久关闭，不再显示</el-link>
                </div>
            </div> -->
            <slot></slot>
        </el-alert>
    </div>
    <i v-else class="el-icon-chat-line-round" @click="()=>{显示=true}" style="position: absolute; right: 0; top: 5px; color: red;"> </i>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'info',
        },
        showIcon: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        closable: {
            type: Boolean,
            default: true,
        },
        center: {
            type: Boolean,
            default: false,
        },
        closeText: {
            type: String,
            default: '',
        },
        effect: {
            type: String,
            default: 'light',
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            显示: true,
        }
    },
    mounted() {
        if (this.name) this.显示 = !window.localStorage.getItem(this.name);
    },
    methods: {
        async onClose() {
            try {
                await this.$confirm("", "", {
                    confirmButtonText: "本次关闭，刷新后还会显示",
                    cancelButtonText: "永久关闭，不再显示",
                    type: "warning"
                });
                this.$emit('close');
            } catch (error) {
                //永久关闭
                if (this.name) window.localStorage.setItem(this.name, true);
                this.$Alert(error);
            }
            this.显示 = false;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>